<confirm-dialog #alertDialog [showRejectButton]="false" [showCloseButton]="true" [showConfirmButton]="false" [showCloseIcon]="true"></confirm-dialog>